<template>
  <button
    class="cs-btn"
    :class="[cssButton && !isDisabled ? cssButton : 'cs-btn-disabled']"
    :disabled="isLoad || isDisabled"
    @click.stop="onClick"
  >
    <slot name="title"></slot>
    <!-- <slot v-if="!isLoad" name="title"></slot> -->
    <!-- <div v-else>
      <div>.</div>
      <div id="loader-2">
        <div id="shadow-2"></div>
        <div id="box-2"></div>
      </div>
    </div> -->
  </button>
</template>

<script setup>
import {ref, onMounted, onUnmounted, watch} from "vue";
import {storeToRefs} from "pinia";
import {LoaderButtonStore} from "../store/loader-button-store";

const emit = defineEmits(["loaderClick"]);
const {lbtnStatus} = storeToRefs(LoaderButtonStore());

const props = defineProps({
  cssButton: {
    type: String,
    default: "",
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});

let hdTime = null;
let isLoad = ref(false);
let isDisabled = ref(false);

onMounted(() => {
  isDisabled.value = props.isDisabled;
});

onUnmounted(() => {
  if (hdTime) {
    clearTimeout(hdTime);
  }
});

watch(lbtnStatus, (newStatus) => {
  if (!newStatus) {
    stop();
  }
});

const onClick = () => {
  if (isLoad.value) {
    return;
  }

  start();
  emit("loaderClick");
};

const start = () => {
  LoaderButtonStore().start();
  hdTime = setTimeout(() => {
    isLoad.value = true;
  }, 1000);
};

const stop = () => {
  if (hdTime) {
    clearTimeout(hdTime);
    hdTime = null;
  }

  isLoad.value = false;
};

const setDisabled = (disabled) => {
  isDisabled.value = disabled;
};

defineExpose({stop, setDisabled});
</script>

<style lang="scss"></style>
